module.exports = __webpack_public_path__ + "static/media/comment-alt-dollar.e5e61251.svg";